import React, { Component } from "react";
import ResultsNav from "./ResultsNav/ResultsNav";
import ResultsTable from "./ResultsTable/ResultsTable";
import RedoSearch from "./RedoSearch/RedoSearch";
import Loading from "../Loading/Loading";
import "./SearchResults.css";

class SearchResults extends Component {
	componentWillMount() {
		//this.industries = this.props.returnIndustriesArray();
		this.searchResults = this.props.refreshedSearchResults();
		this.props.setQueryRedoSearch();
	}
	render() {
		this.queryTypeSingular = this.props.query.type.slice(0, -1);

		return (
			<div className="search-results-container container">
			{this.props.requestInProgress === true && <Loading />}
				<RedoSearch
					getQuery={this.props.getQuery}
					revealSearchPanel={this.props.revealSearchPanel}
					countries={this.props.countries}
					queryTypeSingular={this.queryTypeSingular}
					query={this.props.query}
					//industries={this.industries}
					searchProducts={this.props.searchProducts}
					addSearchTypeToQuery={this.props.addSearchTypeToQuery}
					buildSearchQuery={this.props.buildSearchQuery}
					moreFilters={this.props.moreFilters}
					toggleMoreFilters={this.props.toggleMoreFilters}
					validateSearchQuery={this.props.validateSearchQuery}
				/>
				{this.props.revealSearchPanel === true && (
					<div
						className="redo-search-overlay"
						onClick={() => this.props.toggleLeftSearchPanel()}
					/>
				)}
				<ResultsNav
					query={this.props.query}
					getQuery={this.props.getQuery}
					searchResults={this.searchResults}
					dataToExport={this.props.dataToExport}
					toggleLeftSearchPanel={this.props.toggleLeftSearchPanel}
				/>
				<ResultsTable
					query={this.props.query}
					searchResults={this.searchResults}
					selectDataToExport={this.props.selectDataToExport}
					changeLocation={this.props.changeLocation}
					changeLocation2={this.props.changeLocation2}
				/>
			</div>
		);
	}
}

export default SearchResults;


// WEBPACK FOOTER //
// ./src/components/SearchResults/SearchResults.js